import * as React from "react"

const SvgCloudError = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.5 20.714q-2.3 0-3.9-1.6-1.6-1.599-1.6-3.9 0-1.925 1.188-3.425A5.3 5.3 0 0 1 5.25 9.864q.075-.2.15-.387.075-.188.15-.413L2.1 5.614a.95.95 0 0 1-.275-.7q0-.424.275-.7a.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275l17 17a.98.98 0 0 1 .288.688.93.93 0 0 1-.288.712.98.98 0 0 1-.688.288.97.97 0 0 1-.712-.263l-1.95-1.925zm0-2h8.65l-8.05-8.05a7 7 0 0 0-.075.525 5 5 0 0 0-.025.525h-.5q-1.45 0-2.475 1.025A3.37 3.37 0 0 0 3 15.214q0 1.45 1.025 2.475A3.37 3.37 0 0 0 6.5 18.714m15.1.75-1.45-1.4a2.3 2.3 0 0 0 .638-.812A2.5 2.5 0 0 0 21 16.214q0-1.05-.725-1.775t-1.775-.725H17v-2q0-2.075-1.463-3.537Q14.075 6.714 12 6.714q-.675 0-1.3.163a4.5 4.5 0 0 0-1.2.512L8.05 5.94a7 7 0 0 1 1.862-.912A6.9 6.9 0 0 1 12 4.714q2.925 0 4.962 2.038Q19.001 8.789 19 11.714q1.725.201 2.863 1.488A4.4 4.4 0 0 1 23 16.214a4.38 4.38 0 0 1-1.4 3.25" />
  </svg>
)
export default SvgCloudError
